// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2NWfH","info":"PatientInfo_info__3YrHu"};